export default __webpack_public_path__ + "static/media/cubo-gold.972d8721.svg";